import i18n from "../../i18n";
import React from "react";
import { Sprout } from "lucide-react";

export default function BrandFooter() {
    return (
        <footer className="aj-internal-footer" data-testid="aj-internal-footer">
            <Sprout className="w-4 h-4" aria-hidden="true" />
            <span>{i18n.t("final.cf86f160deef")}</span>
            <span className="text-aj-gold/60" aria-hidden="true">•</span>
            <span>{i18n.t("final.a77a70c1dafa")}</span>
        </footer>
    );
}
